import React, {useEffect} from 'react';

import {Controller, useFieldArray, UseFormMethods} from 'react-hook-form';
import {useTranslation} from 'react-i18next';
import {v4 as uuidv4} from 'uuid';

import {ReactComponent as CrossIcon} from 'assets/svg/cross.svg';
import {ButtonVariant} from 'components/ui-kit/Button';
import {Icon} from 'components/ui-kit/Icon';
import {Input} from 'components/ui-kit/Input';
import {CreateFactory, CreateFactoryLine} from 'types/profile';

import {
    AddMoreButton,
    ControlContainer,
    FactoryLinesContainer,
    Field,
    LineContainer,
} from './styled';

interface Props {
    formData: UseFormMethods;
    initialFactoryLines?: CreateFactoryLine[];
}

export const FactoryLines: React.FC<Props> = ({formData, initialFactoryLines}) => {
    const {t} = useTranslation();
    const {fields, append, remove} = useFieldArray<CreateFactoryLine>({
        control: formData.control,
        name: `factoryLines`,
    });

    useEffect(() => {
        initialFactoryLines?.forEach((line) => append({...line, storedId: line.id}));
    }, [initialFactoryLines]);

    // useEffect(() => {
    //     fields.forEach((_, index) => {
    //         formData.register(`factoryLines.${index}.name`);
    //         formData.register(`factoryLines.${index}.code`);
    //     });
    // }, [fields, formData.register]);

    const addLine = () => {
        append({
            customId: uuidv4(),
            name: '',
        });
    };

    const removeLine = (index: number) => {
        if (fields.length > 1) remove(index);
    };

    return (
        <>
            <FactoryLinesContainer>
                {fields.map((line, lineIndex) => (
                    <LineContainer key={line.id}>
                        <Field>
                            <Controller
                                defaultValue={line.name}
                                name={`factoryLines.${lineIndex}.name`}
                                control={formData.control}
                                render={({onChange, onBlur, value, name}) => (
                                    <Input
                                        name={name}
                                        value={value}
                                        onChange={onChange}
                                        onBlur={onBlur}
                                        placeholder={`${t(
                                            'pages.profile.createFactory.line',
                                        )} ${lineIndex + 1}`}
                                    />
                                )}
                            />
                        </Field>
                        <Controller
                            name={`factoryLines.${lineIndex}.storedId`}
                            defaultValue={line.storedId}
                            control={formData.control}
                            render={({value}) => <input type="hidden" value={value} />}
                        />
                        <ControlContainer
                            disabled={fields.length <= 1}
                            onClick={() => removeLine(lineIndex)}
                        >
                            <Icon source={CrossIcon} width={16} height={16} />
                        </ControlContainer>
                    </LineContainer>
                ))}
            </FactoryLinesContainer>
            <AddMoreButton onClick={addLine} variant={ButtonVariant.Text} type="button">
                + {t('pages.profile.createFactory.addLine')}
            </AddMoreButton>
        </>
    );
};
